export const authUrlGenerator = (url: string, pathname: string, search: string) => (): string => {
  if (pathname.startsWith("/")) {
    pathname = pathname.substring(1);
  }

  return `${url}${pathname}${search}`;
};
